<template>
  <div class="v-baidumap">
    <baidu-map
      class="map"
      :center="mapCenter"
      :zoom="mapZoom"
      @ready="ready"
      :scroll-wheel-zoom="true"
    >
      <template v-for="place in places">
        <bm-marker
          v-bind:key="place.name"
          :position="{ lng: place.position[0], lat: place.position[1] }"
          @click="handleMarkerClick(place)"
        >
          <bm-label
            :content="place.name"
            :labelStyle="{ color: 'red', fontSize: '16px' }"
            :offset="{ width: -30, height: 30 }"
          />
        </bm-marker>
      </template>

      <bm-transit
        v-if="transitDirection.start != '' && transitDirection.end != ''"
        :start="transitDirection.start"
        :end="transitDirection.end"
        :auto-viewport="true"
        :panel="true"
        location="贵阳"
      ></bm-transit>
      <bm-driving
        v-if="drivingDirection.start != '' && drivingDirection.end != ''"
        :start="drivingDirection.start"
        :end="drivingDirection.end"
        :auto-viewport="true"
        policy="BMAP_DRIVING_POLICY_LEAST_TIME"
        :panel="true"
        location="贵阳"
        @searchcomplete="drivingSearchComplete"
      >
      </bm-driving>
    </baidu-map>
    <el-button
      v-show="isTripButtonVisible"
      type="primary"
      icon="el-icon-document"
      circle
      class="btn-float btn-show-drawer"
      @click="showDrawer"
    ></el-button>
    <el-button
      type="primary"
      round
      class="btn-float btn-show-transit_direction"
      @click="showTransitDirection"
      :disabled="startPoint == '' || endPoint == ''"
      >公交路线</el-button
    >
    <el-button
      type="primary"
      round
      class="btn-float btn-show-driving_direction"
      @click="showDrivingDirection"
      :disabled="startPoint == '' || endPoint == ''"
      >打车路线</el-button
    >
    <!-- <el-button
      type="primary"
      round
      class="btn-float btn-show-baidu_direction"
      @click="showBaiduDirection"
      :disabled="startPoint == '' || endPoint == ''"
      >百度地图</el-button
    > -->
    <el-drawer
      title="行程"
      :visible.sync="drawer"
      direction="btt"
      :show-close="false"
      size="90%"
      @closed="onDrawerClosed"
    >
      <el-menu
        :default-active="menuActiveIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleChangeTripBy"
      >
        <el-menu-item index="1">按地点</el-menu-item>
        <el-menu-item index="2">按时间(10/05)</el-menu-item>
        <el-menu-item index="3">按时间(10/06)</el-menu-item>
        <el-menu-item index="4">按时间(10/07)</el-menu-item>
      </el-menu>
      <div class="tripWrapper">
        <div v-if="menuActiveIndex == 1" class="m-trip_by_place">
          <trip-place
            v-for="place in places"
            :key="place.name"
            :place="place"
          ></trip-place>
        </div>
        <div v-if="menuActiveIndex >= 2" class="m-trip_by_date">
          <el-timeline>
            <el-timeline-item
              v-for="timelinePlace in timelinePlaces"
              :key="timelinePlace.time"
              :timestamp="timelinePlace.time"
              placement="top"
            >
              <el-card>
                <div slot="header" class="clearfix">
                  <span>{{ timelinePlace.place }}</span>
                  <el-button
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="setMapCenter(timelinePlace.place)"
                    >在地图上显示</el-button
                  >
                </div>
                <p class="text-blue">游玩时间：{{ timelinePlace.duration }}</p>
                <p>{{ timelinePlace.comments }}</p>
                <p class="text-muted">{{ timelinePlace.transportation }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :title="placeDialogTitle"
      :visible.sync="placeDialogVisible"
      width="50%"
    >
      <div>{{ placeDialogDetails }}</div>
      <div>
        <el-link :href="placeDialogLink" target="_blank"
          >查看攻略<i class="el-icon-view el-icon--right"></i
        ></el-link>
      </div>
      <div><el-link type="primary">去地图</el-link></div>
      <div>
        <el-button
          type="primary"
          @click="
            selectLocation('start', {
              lng: placeDialogLocation[0],
              lat: placeDialogLocation[1],
            })
          "
          >设为起点</el-button
        >
        <el-button
          type="success"
          @click="
            selectLocation('end', {
              lng: placeDialogLocation[0],
              lat: placeDialogLocation[1],
            })
          "
          >设为终点</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TripPlace from "../components/TripPlace.vue";
import { places, schedule } from "../assets/guide/guiyang.json";
export default {
  components: {
    TripPlace,
  },
  data() {
    return {
      mapCenter: {
        lng: 106.681826,
        lat: 26.625637,
      },
      mapZoom: 13,
      drawer: false,
      isTripButtonVisible: true,
      menuActiveIndex: "1",
      places: places,
      placeDialogTitle: "",
      placeDialogVisible: false,
      placeDialogDetails: "",
      placeDialogLink: "",
      placeDialogLocation: {},
      transitDirection: {
        start: "",
        end: "",
      },
      drivingDirection: {
        start: "",
        end: "",
      },
      startPoint: "",
      endPoint: "",
      timelinePlaces: [],
    };
  },
  methods: {
    ready({ Bmap, map }) {
      console.log(BMap);
      console.log(schedule);
    },
    showDrawer() {
      this.isTripButtonVisible = false;
      this.drawer = true;
    },
    onDrawerClosed() {
      this.isTripButtonVisible = true;
    },
    handleChangeTripBy(index) {
      this.menuActiveIndex = index;
      console.log(index);
      if (index === "2") {
        this.timelinePlaces = schedule["10/05"];
        console.log(schedule["10/05"]);
      } else if (index === "3") {
        this.timelinePlaces = schedule["10/06"];
      } else if (index === "4") {
        this.timelinePlaces = schedule["10/07"];
      }
    },
    handleMarkerClick(place) {
      this.transitDirection = {
        start: "",
        end: "",
      };
      this.renderPlaceDialog(
        place.name,
        place.datails,
        place.link,
        place.position
      );
    },
    renderPlaceDialog(title, details, link, location, map = null) {
      this.placeDialogTitle = title;
      this.placeDialogDetails = details;
      this.placeDialogLink = link;
      this.placeDialogLocation = location;
      this.placeDialogVisible = true;
    },
    selectLocation(type, location) {
      if (type === "start") {
        this.startPoint = location;
      }
      if (type === "end") {
        this.endPoint = location;
      }
      this.placeDialogVisible = false;
    },
    showTransitDirection() {
      this.transitDirection = {
        start: this.startPoint,
        end: this.endPoint,
      };
    },
    showDrivingDirection() {
      this.drivingDirection = {
        start: this.startPoint,
        end: this.endPoint,
      };
    },
    drivingSearchComplete(results) {
      let plan = results.getPlan(0);
      this.$alert(
        `需要${plan.getDuration(true)}，${plan.getDistance(true)}`,
        "路线详情",
        {
          confirmButtonText: "确定",
          callback: (action) => {
            this.$message({
              type: "info",
              message: `action: ${action}`,
            });
          },
        }
      );
    },
    setMapCenter(name) {
      let thisPlace = null;
      places.forEach((place) => {
        if (place.name === name) {
          thisPlace = place;
        }
      });
      if (thisPlace) {
        this.drawer = false
        this.mapCenter = {
          lng: thisPlace.position[0],
          lat: thisPlace.position[1],
        };
        this.mapZoom = 15
      }
    },
    showBaiduDirection() {
      let baiduUrl = `http://api.map.baidu.com/direction?origin=latlng:${this.startPoint.lat},${this.startPoint.lng}&destination=latlng:${this.endPoint.lat},${this.endPoint.lng}&mode=driving&region=贵阳&output=html&src=xyz.xiaogongju.trip`;
      window.open(baiduUrl);
      console.log(baiduUrl);
    },
  },
};
</script>

<style>
.v-baidumap {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
}
/* 地图容器必须设置宽和高属性 */
.map {
  width: 100%;
  height: 100%;
}
.btn-show-drawer {
  position: fixed;
  right: 30px;
  bottom: 20px;
  z-index: 10;
}
.btn-show-transit_direction {
  position: fixed;
  right: 30px;
  top: 20px;
  z-index: 10;
}
.btn-show-driving_direction {
  position: fixed;
  right: 160px;
  top: 20px;
  z-index: 10;
}
.btn-show-baidu_direction {
  position: fixed;
  right: 290px;
  top: 20px;
  z-index: 10;
}
.el-drawer__body {
  height: 100%;
}
.tripWrapper {
  margin-top: 20px;
  overflow: scroll;
  padding-bottom: 200px;
  height: 100%;
  text-align: left;
}
div:has(table > tbody > tr.tranroute-plan-list) {
  position: fixed;
  bottom: 0;
}
.el-card {
  margin-right: 30px;
}
.text-blue {
  color: #409eff;
}
.text-muted {
  font-size: 0.9em;
  color: gray;
}
</style>
